<template>
  <div class="audioTitle">
    <!-- 合辑 -->
    <template v-if="$route.name === 'audioAlbum'">
      <div class="title-content">
        <div class="surface_pic">
          <img :src="aciObj.surface_pic" alt="">
          <div class="zhuanji">合辑</div>
        </div>
        <div class="title-right">
          <h3 v-if="aciObj.title">{{aciObj.title.slice(0,18)}}</h3>
          <div class="author_name">
            <img :src="aciObj.author_pic" alt="">
            <span v-if="aciObj.author_name">{{aciObj.author_name.slice(0,18)}}</span>
          </div>
        </div>
      </div>
      <div class="synopsis">
        <p class="synopsis-text" :class="{ zhankai: !iszhankai }">简介：{{aciObj.intro}}</p>
        <span @click="zhankaiFn" v-if="aciObj.intro && aciObj.intro.length > 48">
          <img v-if="!iszhankai" src="../assets/img/zhankan.png" alt="">
          <img v-if="iszhankai" src="../assets/img/shouqi.png" alt="">
        </span>
      </div>
    </template>
    <template v-if="$route.name === 'audioList'">
      <div class="title-content">
        <div class="surface_pic">
          <img :src="albumObj.pic" alt="">
          <div class="zhuanji" style="background: #1cc5ec;">专辑</div>
        </div>
        <div class="title-right">
          <h3 v-if="albumObj.name">{{albumObj.name.slice(0,18)}}</h3>
          <div class="author_name">
            <img :src="videoObj.pic" alt="">
            <span v-if="videoObj.name">{{videoObj.name.slice(0,18)}}</span>
          </div>
        </div>
      </div>
      <div class="synopsis">
        <p class="synopsis-text" :class="{ zhankai: !iszhankai }">简介：{{albumObj.description}}</p>
        <span @click="zhankaiFn" v-if="albumObj.description && albumObj.description.length > 48">
          <img v-if="!iszhankai" src="../assets/img/zhankan.png" alt="">
          <img v-if="iszhankai" src="../assets/img/shouqi.png" alt="">
        </span>
      </div>
    </template>
    
  </div>
</template>

<script>
  import wechat from "@/plugins/wx";

  export default {
    props: {
      aciObj: {
        type: Object,
        default: ()=> ({
          id: null
        })
      },
    },
    data() {
      return {
        iszhankai: false,
        videoObj: {},
        albumObj: {},
        shareConfig: {
          title: '分享标题',
          desc: '这是一个测试的微信分享',
          link: '', // 分享链接
          imgUrl: '', // 分享图标
        },
      }
    },
    created () {
      if(this.$route.name === 'audioList'){
        this.getAlbum()
      }
    },
    methods: {
      zhankaiFn(){
        this.iszhankai = !this.iszhankai
      },
      async getAlbum(){
        try {
          this.id = this.$route.query.id || 'faf1460e-743f-4fa5-8c98-8840cdf216b8'
          //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/album/${this.id}`)
          const res = await this.axios.get(`https://api.ayerdudu.com/v1/album/${this.id}`)
          this.albumObj = res.data.data
          const currentUrl = window.location.href.split('#')[0];
          this.shareConfig.title = this.albumObj.name;
          this.shareConfig.desc = this.albumObj.description;
          this.shareConfig.link = currentUrl;
          this.shareConfig.imgUrl = this.albumObj.pic;
          console.log('分享配置',this.shareConfig);
          //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
          wechat.initConfig(currentUrl).then(() => {
            // 配置分享内容
            wechat.setShareOptions(this.shareConfig);
          });
          //const res2 = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/user/${this.albumObj.user_id}`)
          const res2 = await this.axios.get(`https://api.ayerdudu.com/v1/user/${this.albumObj.user_id}`)
          this.videoObj = res2.data.data
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.audioTitle{
  min-height: 200px;
  padding: 24px 36px;
}
.title-content{
  height: 250px;
  display: flex;
  .surface_pic{
    width: 250px;
    height: 250px;
    position: relative;
    overflow: hidden;
    border: 1px solid #eee;
    border-radius: 18px;
    img{
      width: 100%;
      height: 100%;
      // border-radius: 10px;
    }
    .zhuanji{
      position: absolute;
      top: -50px;
      right: -46px;
      background: #22b07d;
      color: #fff;
      width: 112px;
      height: 112px;
      border-radius: 50%;
      line-height: 160px;
      font-size: 24px;
      text-indent: 12px;
      // transform: scale(0.7);
    }
  }
  .title-right{
    flex: 1;
    margin-left: 40px;
    h3{
      line-height: 54px;
      font-size: 38px;
      margin: 30px 0 15px 0;
      color: #000;
      font-weight: bold;
    }
    .author_name{
      height: 46px;
      font-size: 0;
      img{
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: 1px solid #eee;
        overflow: hidden;
        float: left;
      }
      >span{
        float: left;
        line-height: 52px;
        margin-left: 12px;
        font-size: 25px;
      }
    }
  }
  margin-bottom: 32px;
}
.synopsis{
  font-size: 24px;
  color: #888;
  line-height: 36px;
  display: flex;
  .synopsis-text{
    flex: 1;
    line-height: 37px;
    &.zhankai{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  >span{
    width: 20px;
    position: relative;
    cursor: pointer;
    >img{
      width: 30px;
      height: 30px;
      position: absolute;
      bottom: 0;
    }
  }
}

</style>